import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=6114b16a&"
import script from "./Supplier.vue?vue&type=script&lang=ts&"
export * from "./Supplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports